var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.98 4C7.57277 4 4 7.57277 4 11.98C4 16.3872 7.57277 19.96 11.98 19.96C16.3872 19.96 19.96 16.3872 19.96 11.98C19.96 7.57277 16.3872 4 11.98 4ZM2 11.98C2 6.4682 6.4682 2 11.98 2C17.4918 2 21.96 6.4682 21.96 11.98C21.96 17.4918 17.4918 21.96 11.98 21.96C6.4682 21.96 2 17.4918 2 11.98Z",
  fill: "inherit"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 15.0105C11.3758 15.0105 10.8699 15.5164 10.8699 16.1405C10.8699 16.7646 11.3758 17.2705 11.9999 17.2705C12.624 17.2705 13.1299 16.7646 13.1299 16.1405C13.1299 15.5164 12.624 15.0105 11.9999 15.0105Z",
  fill: "inherit"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 6.74055C12.5499 6.74055 12.9999 7.19055 12.9999 7.74055L12.9999 13.0605C12.9999 13.6105 12.5499 14.0605 11.9999 14.0605C11.4499 14.0605 10.9999 13.6105 10.9999 13.0605L10.9999 7.74055C10.9999 7.19055 11.4499 6.74055 11.9999 6.74055Z",
  fill: "inherit"
})));
export default SvgError;